import React from "react";
import VisualMic from "../components/VisualMic";

const DogChat = () => {
    <VisualMic />
}

export default DogChat;